import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DocumentPayment, Document, PaymentDocumentInfo } from '../interfaces/interfaces.index';
import { HTTP_OPTIONS, URL_SERVICIOS } from '../shared/config/config';
import { SicoInteractions } from '../interfaces/sico-interactions.interface';
import { map } from 'rxjs/operators';
const URL = `${URL_SERVICIOS}Document/petition`;
const REQUIREMENTS_ASSET = 'assets/requisitosCapacidadPago.json';

const stripBase64Prefix = (docs: Document[]): Document[] =>
  (docs || []).map(d => ({
    ...d,
    attachment: (d.attachment && d.attachment.includes('base64,'))
      ? d.attachment.split('base64,')[1]
      : d.attachment
  }));

@Injectable({
  providedIn: 'root'
})
export class EstudioCapacidadPagoService {

  constructor(private http: HttpClient) { }

  private normalizeRequirements = (items: any[]): PaymentDocumentInfo[] =>
    (items || []).map((item) => ({
      ...item,
      extra: Array.isArray(item.extra) ? item.extra : [],
      notes: Array.isArray(item.notes) ? item.notes : Array.isArray(item.note) ? item.note : []
    }));

  getProperty = (_petitionId: number | string) =>
    this.http.get<any[]>(REQUIREMENTS_ASSET, HTTP_OPTIONS).pipe(
      map(items => this.normalizeRequirements(items))
    );

  saveDocument = (petitionId: number, paymentCapacityId: number, doc: Document[]) =>
    this.http.post(`${URL}/${petitionId}/paymentCapacity/${paymentCapacityId}`, stripBase64Prefix(doc), HTTP_OPTIONS)

  saveVehicleDocuments = (petitionId: number, doc: Document[]) =>
    this.http.post(`${URL_SERVICIOS}Document/SaveDocumentprocess/${petitionId}`, stripBase64Prefix(doc), HTTP_OPTIONS)

}
